import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import $ from "jquery";
import { AccountDropdown, Site, Nav } from "tabler-react";
import MyPolygon from "./MyPolygon.js";
import {
  SuperLightBox,
  HeaderBox,
  HeaderNavigationBox,
  LightboxText,
} from "../../component";
import "./style.css";
import { history } from "../../utils/helpers/history";
import { helper } from "../../utils/helpers/helper";
import { alertActions, userActions, mapActions } from "../../store/actions";
class SiteWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      ShowSuperLightBox: false,
      toggle: true,
    };

    history.listen((location, action) => {
      // clear alert on location change
      this.props.clearAlerts();
    });
  }
  // PERMISSION CHECK FOR MY GEOFENCE
  getMyGeofence = () => {
    // let localStorageSubscription = JSON.parse(localStorage.getItem('subscription_details'));
    //ACCESS TO ADMIN AND USER LEVEL 2
    // if(localStorageSubscription?.subscription_level === null || localStorageSubscription?.subscription_level === 2){
    return (
      <li className="nav-item my-polygon-list">
        <MyPolygon />
      </li>
    );
    // } else return "";
  };

  // CLOSE CHECK FOR Geofencing
  closeMyGeofenceIcon = () => {
    //CLOSE MY POLYGONS LIST
    const { showMyPolygonListAction } = this.props;
    $("#root").on("click", function (e) {
      if (e.target.id === "myPolygonList") return 0;
      showMyPolygonListAction(false);
    });
  };

  getMyGeofence = () => {
    // let localStorageSubscription = JSON.parse(localStorage.getItem('subscription_details'));
    //ACCESS TO ADMIN AND USER LEVEL 2
    // if(localStorageSubscription?.subscription_level === null || localStorageSubscription?.subscription_level === 2){
      return (
      <li className="nav-item my-polygon-list">
        <MyPolygon />
      </li>
    );
    // } else return "";
  }

  handlerSuperLightBox = () => {
    // this.setState({ ShowSuperLightBox: !this.state.ShowSuperLightBox });
    const contact = (
      <>
        {/* CONTENT */}
        <div className="contact-us text-center">
          <i className="fe fe-mail"></i>
          <h3>Email us now</h3>
          <p>We're here to help.</p>
          <a className="link-success" href="mailto:ras@whisperingbell.com">
            ras@whisperingbell.com
          </a>
        </div>
      </>
    );
    this.refs.lightbox.openPopupbox(contact);
  };

  handlerToggler = () => {
    this.setState({ toggle: !this.state.toggle });
  };

  // LOGOUT HANDLER
  handlelogout = (e) => {
    if (e.target) {
      this.props.logout(this.props);
    }
  };

  // GUIDED HANDLER
  startGuidedTour = (e) => {
    if (e.target) {
      this.props.guidedTour(true);
    }
  };

  componentDidMount(prevProps) {
    this.closeMyGeofenceIcon();
    let user = this.props.user;
    let localUser = JSON.parse(localStorage.getItem("user"));
    let name = user === null ? localUser : user;
    const first_name = !!name?.first_name ? name?.first_name : "Test";
    const last_name = !!name?.last_name ? name?.last_name : "User";
    const username = first_name + " " + last_name;
    this.setState({ username });
    //flex-lg-row
    $(".order-lg-first > .flex-lg-row > li:last-child").on("click", (e) =>
      this.handlelogout(e)
    );
    $(".order-lg-2 > .dropdown > .nav > li:last-child").on("click", (e) =>
      this.handlelogout(e)
    );
    $(".order-lg-first > .flex-lg-row > li:nth-last-child(2)").on(
      "click",
      (e) => this.handlerSuperLightBox(e)
    );
    $(".order-lg-2 > .dropdown > .nav > li:nth-last-child(2)").on(
      "click",
      (e) => this.handlerSuperLightBox(e)
    );
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.showMyPolygonList === true) {
      this.closeMyGeofenceIcon();
    }
    let user = JSON.parse(localStorage.getItem("user"));
    const first_name = !!user?.first_name ? user?.first_name : "Test";
    const last_name = !!user?.last_name ? user?.last_name : "User";
    const username = first_name + " " + last_name;
    this.setState({ username });
  }

  render() {
    const { toggle } = this.state;
    const user_type = localStorage.getItem("user_type");
    const userRole = helper.get_user_role(user_type);
    const { username, ShowSuperLightBox } = this.state;
    const navBarItems = [
      {
        value: "Home",
        to: "/",
        icon: "home",
        // LinkComponent: withRouter(NavLink),
        RootComponent: withRouter(NavLink),
        useExact: true,
      },
      {
        value: "Profile",
        to: "/profile",
        icon: "user",
        // LinkComponent: withRouter(NavLink),
        RootComponent: withRouter(NavLink),
      },
      {
        value: "Change Password",
        to: "/change-password",
        icon: "lock",
        // LinkComponent: withRouter(NavLink),
        RootComponent: withRouter(NavLink),
      },
      {
        value: "Contact Us",
        to: "#",
        icon: "mail",
      },
      {
        value: "Sign out",
        icon: "log-out",
      },
    ];
    return (
      <>
        <div className="header py-4">
          <div className="container">
            <div className="d-flex">
              <a className="header-brand" href="/">
                <HeaderBox data-tut="site-logo">
                  <img
                    src="./demo/logo.png"
                    className="header-brand-img"
                    alt="Whispering Bell"
                  />
                </HeaderBox>
              </a>
              <div className="d-flex order-lg-2 ml-auto">
                <HeaderNavigationBox data-tut="site-mygeofence">
                  <div className="col col-sm order-lg-first">
                    <ul className="nav nav-tabs border-0 flex-column flex-sm-row">
                      <li className="nav-item">
                        <NavLink exact to="/" className="nav-link">
                          <i className="fe fe-home"></i> Home
                        </NavLink>
                      </li>
                      {this.getMyGeofence()}
                      <Nav.Item
                        value="Contact Us"
                        icon="mail"
                        onClick={this.handlerSuperLightBox}
                      >
                        <div
                          style={{
                            "padding-right": "6px !important",
                            overflow: "hidden !important",
                          }}
                        >
                          <SuperLightBox
                            open={ShowSuperLightBox}
                            handler={this.handlerSuperLightBox}
                          >
                            <i className="fe fe-mail"></i>
                            <h3>Email us now</h3>
                            <p>We're here to help.</p>
                            <a
                              className="link-success"
                              href="mailto:ras@whisperingbell.com"
                            >
                              ras@whisperingbell.com
                            </a>
                          </SuperLightBox>
                        </div>
                      </Nav.Item>
                      <LightboxText ref="lightbox" />
                      <div class="nav-item">
                        <button
                          class="btn btn-sm btn-outline-primary"
                          onClick={this.startGuidedTour}
                        >
                          Guided Tour
                        </button>
                      </div>
                    </ul>
                  </div>
                </HeaderNavigationBox>
                <HeaderNavigationBox data-tut="site-account">
                  <AccountDropdown
                    avatarURL="./images/avatar.png"
                    name={helper.capitalizeFirstLetter(username)}
                    description={helper.capitalizeFirstLetter(userRole)}
                    options={[
                      {
                        value: "Profile",
                        to: "/profile",
                        icon: "user",
                        // LinkComponent: withRouter(NavLink),
                        RootComponent: withRouter(NavLink),
                        useExact: true,
                      },
                      {
                        value: "Change Password",
                        to: "/change-password",
                        icon: "lock",
                        // LinkComponent: withRouter(NavLink),
                        RootComponent: withRouter(NavLink),
                        useExact: true,
                      },
                      {
                        value: "Sign out",
                        icon: "log-out",
                        onClick: this.handlelogout,
                      },
                    ]}
                  />
                </HeaderNavigationBox>
              </div>
              <div class="nav-item guidedTour">
                <button
                  class="btn btn-sm btn-outline-primary"
                  onClick={this.startGuidedTour}
                >
                  Guided Tour
                </button>
              </div>
              <a
                className="header-toggler d-lg-none ml-3 ml-lg-0"
                href={() => false}
                onClick={this.handlerToggler}
              >
                <span className="header-toggler-icon"></span>
              </a>
            </div>
          </div>
        </div>
        <Site.Nav collapse={toggle} itemsObjects={navBarItems}></Site.Nav>
        {this.props.children}
      </>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.user;
  const { tokenExpired } = state.jwt;
  const { polyData } = state.drawing;
  const { showMyPolygonList } = state.map;
  return {
    user,
    tokenExpired,
    polyData,
    showMyPolygonList,
  };
}

const mapDispatchToProps = {
  showMyPolygonListAction: mapActions.showMyPolygonListAction,
  clearAlerts: alertActions.clear,
  logout: userActions.logout,
  guidedTour: userActions.guidedTour,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SiteWrapper));
